import { AdContentElement } from "./ad-content-element.model";

export class AdContentUpdate {
	materialId?: string;
	styleId?: string;
	adContentElements!: AdContentElement[];
}
